import supabase from '../supabaseClient';

/**
 * Uploads a file to the specified bucket and path.
 * @param {File} file - The file object to upload.
 * @param {string} bucket - The storage bucket name (default: 'evidence').
 * @param {string} path - The path/filename within the bucket.
 * @returns {Promise<{path: string, url: string, error: any}>}
 */
export const uploadFile = async (file, bucket = 'evidence', path = null) => {
  try {
    if (!file) throw new Error('No file provided');

    // Generate a unique path if not provided
    const filePath = path || `${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.]/g, '_')}`;

    const { data, error } = await supabase.storage
      .from(bucket)
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (error) throw error;

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from(bucket)
      .getPublicUrl(filePath);

    return { path: filePath, url: publicUrl, error: null };
  } catch (error) {
    console.error('Upload error:', error);
    return { path: null, url: null, error };
  }
};

/**
 * Deletes a file from storage.
 * @param {string} path - The file path in the bucket.
 * @param {string} bucket - The bucket name.
 */
export const deleteFile = async (path, bucket = 'evidence') => {
  try {
    const { error } = await supabase.storage
      .from(bucket)
      .remove([path]);

    if (error) throw error;
    return { error: null };
  } catch (error) {
    console.error('Delete error:', error);
    return { error };
  }
};